export function validateAppVersion(currentVersion: string) {
  const storedVersion = localStorage.getItem('APP_VERSION')

  if (!storedVersion || storedVersion !== currentVersion) {
    localStorage.clear()

    sessionStorage.clear()

    if ('caches' in window) {
      caches.keys().then(function (names) {
        for (const name of names) {
          caches.delete(name)
        }
      })
    }
    // Armazena a nova versão
    localStorage.setItem('APP_VERSION', currentVersion)
    window.location.reload()
  }
}
